export const getAccountsIdsAndIndexes = (data: any[]) => {
  const accountsIdsAndIndexes: { [key: string]: number } = {};
  data.forEach((account, index) => {
    accountsIdsAndIndexes[account.id] = index;
  });
  return accountsIdsAndIndexes;
};

export const adjustOrder = (
  order: Record<string, number>,
  accounts: { id: string }[]
) => {
  const validIds = new Set(accounts.map((acc) => acc.id));

  const filteredOrderEntries = Object.entries(order)
    .filter(([id]) => validIds.has(id))
    .sort((a, b) => a[1] - b[1]);

  const newOrder = Object.fromEntries(
    filteredOrderEntries.map(([id], index) => [id, index])
  );

  return newOrder;
};

export const fiatTypeAccounts = [
  "FIAT_TESTNET_USD",
  "FIAT_MAINNET_USD",
  "FIAT_TESTNET_EUR",
  "FIAT_MAINNET_EUR",
  "FIAT_TESTNET_EUR",
  "FIAT_MAINNET_EUR",
];
